var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6947_146589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.35675 8C8.35777 7.93442 8.34115 7.86941 8.30793 7.80913C8.27472 7.74885 8.22565 7.69465 8.16389 7.65L2.37818 3.15C2.12103 2.95 1.72246 2.95 1.46532 3.15C1.20818 3.35 1.20818 3.66 1.46532 3.86L6.80103 8.01L1.47818 12.15C1.22103 12.35 1.22103 12.66 1.47818 12.86C1.73532 13.06 2.13389 13.06 2.39103 12.86L8.17675 8.36C8.30532 8.26 8.3696 8.13 8.3696 8.01L8.35675 8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6947_146589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9,
    fill: "white",
    transform: "matrix(0 1 1 0 0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.a1377b4d185c9b8bbb985f8435953888.svg";
export { ForwardRef as ReactComponent };